module.exports = "<div>\n    <h3>Portfolio</h3>\n</div>\n<div *ngIf=\"!!tags && tags.length > 1\" class=\"tags\">\n    <span>Filter: </span>\n    <span class=\"tag selectable\" *ngFor=\"let tag of tags\" (click)=\"filterByTag(tag)\" [class.selected]=\"tag === selectedTag\">{{tag}}</span>\n<div>\n<div class=\"projects\">\n    <project *ngFor=\"let project of projects | tagfilter: selectedTag\" [project]=\"project\"></project>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/+portfolio/portfolio.html
// module id = ../../../../../src/app/+portfolio/portfolio.html
// module chunks = 1